export function update(user) {
    return {
        type: 'USER_DATA',
        user
    };
}
